import { Box, IconButton, MenuItem, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const CardContainer = styled(Box)(() => ({
  margin: '4px',
  padding: '6px',
  borderBottom: '1px solid #0000003b',
  display: 'flex',
  justifyContent: 'space-between',
}));

export const FlexBox = styled(Box)(() => ({
  display: 'flex',
  gap: '10px',
  alignItems: 'center',
}));

export const NumberTypography = styled(Typography)(({ theme }) => ({
  fontSize: '18px',
  fontWeight: '600',
  color: theme.palette.secondary.main,
}));

export const Title = styled(Typography)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
}));

export const StyledMenuItem = styled(MenuItem)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
}));

export const MenuButton = styled(IconButton)(() => ({
  borderRadius: '50%',
  padding: '0 2px',
  '&:hover': {
    '& span': {
      fontSize: '26px',
      fontWeight: '600',
    },
    padding: '0 1px',
  },
}));

export const CheckboxStyle = {
  padding: '4px',
  '&.Mui-checked': {
    color: '#595959',
  },
};
